<div
    class="expander-button"
    (click)="handleClick($event)"
>
    <i class="{{ iconClassName }}"></i>
</div>
